import React from "react";
import classNames from "classnames";
import {observer} from "mobx-react";
import styles from "../styles/navigation-tabs.module.scss";
import {KeyboardArrowLeft} from "../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../../core/icons/keyboard-arrow/keyboard-arrow-right";
import {NAVIGATION_TABS} from "../navigation-tabs-module.consts";

export const NavigationTabsModuleArrowBackward = observer(({controller, onClick, shouldRenderArrow, isScrollable}) => {
  const {device: {isRtl}} = controller;

  const containerProps = {
    className: classNames(styles.arrow_container, {[styles.disable_arrow]: !shouldRenderArrow}),
  }

  const prevProps = {
    className: classNames(styles.arrow),
    onClick: () => onClick(NAVIGATION_TABS.DIRECTIONS.prev)
  }

  return (
     isScrollable ? <div {...containerProps}>
      {
        shouldRenderArrow ? isRtl ? <KeyboardArrowRight {...prevProps}/> : <KeyboardArrowLeft {...prevProps}/> : null
      }
    </div> : null
  )
});
